import "./OnlineMenuHome.scss";
import OnlineMenuHomeHook from "./OnlineMenuHomeHook";
import ToolBarTemplate from "../../components/experience/toolbar/ToolBarTemplate";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useTranslation } from "react-i18next";
import { Box, Card, CardMedia, Divider } from "@mui/material";
import SwipeableViews from "react-swipeable-views";
import React, { ReactNode, useState, useEffect } from "react";
import { getImage } from "../../api/ApiPath";
import { FoodsObj } from "../../api/model/response/OnlineMenuResponseModel";
import { routes } from "../../__product__/navigation/routes";
import TelescopePopover from "../../components/atom/pop_over/TelescopePopover";
import OnlineMenuService, { StatisticIdentifiers } from "../../api/service/OnlineMenuService";
import LoadingPage from "../../components/experience/loading/LoadingPage";
import TelescopeImage from "../../components/atom/image/TelescopeImage";
import { ShoppingCart, Warning } from "@mui/icons-material";
import GoBackButton from "../../components/experience/goBackButton/goBackButton";
import { useUserContext } from "../../context/UserContext";
import AddToCartIcon from "../../components/experience/addToCartIcon/addToCartIcon";
import { useMyNavigate } from "../../__product__/navigation/myNavigate";
const OnlineMenuHome = () => {
  const { currentOnlineMenu, currentCompanyInfo, isLoading, selectedTab, handleTabChange, setSelectedTab } =
    OnlineMenuHomeHook();
  const { t } = useTranslation();
  const navigate = useMyNavigate();
  const { statisticRequest } = OnlineMenuService();
  const { setOrders, orders, isCartActive } = useUserContext();
  const [isPressed, setIsPressed] = useState<string>("");

  function getTotalNumberOfOrder() {
    let ret = 0;
    orders.forEach((order) => {
      ret += order.quantity;
    });
    return ret;
  }

  function renderTabArea() {
    return (
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons={false}
        TabIndicatorProps={{
          style: {
            backgroundColor: `${currentOnlineMenu.otherColor}`
          }
        }}
        sx={{
          ".Mui-selected": {
            color: currentOnlineMenu.otherColor ? currentOnlineMenu.otherColor + "!important" : "black !important"
          }
        }}
      >
        {currentOnlineMenu?.categoriesObj?.map((value, index) => {
          return (
            <Tab
              key={index}
              style={{
                color: currentOnlineMenu.titleColor ?? "black"
              }}
              label={value.title}
              icon={
                value.photoUrl ? (
                  <img className={"home-categories-image"} src={getImage(value.photoUrl)} alt={value.title} />
                ) : (
                  <span
                    className={`telescope-image`}
                    style={{ width: "80px", height: "80px", backdropFilter: `brightness(0.98)` }}
                  />
                )
              }
            />
          );
        })}
      </Tabs>
    );
  }

  function TabPanel(props: TabPanelProps) {
    const { children, value, index } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        className={"home-tab-panel"}
        color={currentOnlineMenu.titleColor ?? "black"}
        style={{ backgroundColor: currentOnlineMenu?.backgroundColor ?? "white" }}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <div>{children}</div>
          </Box>
        )}
      </div>
    );
  }

  function renderFoodObj(food: FoodsObj, categoryId: string, isFoodDetail = false, isSubfood = false) {
    const allergens = food.ingredientsObj?.filter((x) => x.isAllergen === 1);
    const ingredients = food.ingredientsObj?.filter((x) => x.isAllergen === 0);
    return (
      <>
        <Card
          role={"button"}
          onClick={() => {
            void statisticRequest({
              // TODO : statistic
              url: window.location.pathname,
              objId: food.id,
              onlineMenuId: currentOnlineMenu.id,
              identifier: StatisticIdentifiers.FOOD_DETAIL_VIEW
            });
          }}
          style={{ backgroundColor: currentOnlineMenu?.backgroundColor ?? "white" }}
          className={"panel-item"}
          elevation={0}
        >
          <div className={"food-tags"}>
            {food.foodTagsObj?.map((tag, i) => {
              return (
                <div
                  style={{
                    backgroundColor: currentOnlineMenu.otherColor ?? "var(--helper-danger-900)",
                    color: currentOnlineMenu?.titleColor ?? "white"
                  }}
                  className={"item"}
                  key={i}
                >
                  {`#${tag.title}`}
                </div>
              );
            })}
          </div>
          {isFoodDetail && ingredients && (
            <div className={"iyilestir-subtitle-medium"}>{ingredients.length > 0 ? t("ingredients") : ""}</div>
          )}
          {isFoodDetail && (
            <div className={"ingredients-area"}>
              {ingredients?.map((value, i) => {
                return (
                  <div className={"iyilestir-caption"} key={i}>
                    {value.title}
                  </div>
                );
              })}
            </div>
          )}
          {isFoodDetail && allergens && (
            <div className={"iyilestir-subtitle-medium"}>{allergens?.length > 0 ? t("allergens") : ""}</div>
          )}
          {isFoodDetail && (
            <div className={"ingredients-area"}>
              {allergens?.map((value, i) => {
                return (
                  <div className={"iyilestir-caption"} key={i}>
                    {value.title}
                  </div>
                );
              })}
            </div>
          )}
          {food?.photoUrl && (
            <CardMedia component="img" height="192" image={getImage(food?.photoUrl)} alt={food.title} />
          )}
          <div className={"price-title-area"}>
            <div
              className={isSubfood ? "subfood-title" : "food-title"}
              style={{ color: currentOnlineMenu?.titleColor ?? "black" }}
            >
              {food?.title}
            </div>
            <div className="price-plus-area">
              <div className={"price-area"}>
                {(isCartActive ? food.orderPrice : food?.price) && (
                  <div
                    className={`iyilestir-subtitle-bold ${
                      food.discountedPrice !== null && !isCartActive && "old-price"
                    }`}
                    style={{ color: currentOnlineMenu?.titleColor ?? "black" }}
                  >{`${currentOnlineMenu.currecyTitle}${isCartActive ? food.orderPrice : food?.price}`}</div>
                )}
                {!isCartActive && food?.discountedPrice && (
                  <div
                    className={`iyilestir-subtitle-bold`}
                    style={{ color: currentOnlineMenu?.titleColor ?? "black" }}
                  >{`${currentOnlineMenu.currecyTitle}${food?.discountedPrice}`}</div>
                )}
              </div>
              <AddToCartIcon
                food={food}
                type={isSubfood ? "subfood" : "food"}
                isPressed={isPressed}
                setIsPressed={setIsPressed}
                backgroundColor={currentOnlineMenu.otherColor}
                color={currentOnlineMenu.titleColor}
                categoryId={categoryId}
              />
            </div>
          </div>
          <div className={"iyilestir-caption"} style={{ color: currentOnlineMenu?.titleColor ?? "black" }}>
            {food?.description}
          </div>
          {food?.warningText && (
            <div className={"warning-text"}>
              <Warning style={{ color: currentOnlineMenu.otherColor ?? "orange" }} /> {food?.warningText}
            </div>
          )}
          {food?.subFoodsObj?.map((value) => {
            return renderFoodObj(value, categoryId, isFoodDetail, true);
          })}
        </Card>
        {!isFoodDetail && !isSubfood && <Divider />}
      </>
    );
  }

  function renderGoBackArrowButton() {
    return <GoBackButton />;
  }

  function renderFoodList() {
    return (
      <SwipeableViews
        index={selectedTab}
        onChangeIndex={(index) => {
          setSelectedTab(index);
          navigate(`${routes.food}/${currentOnlineMenu?.categoriesObj[index].id}`);
        }}
        style={{ backgroundColor: currentOnlineMenu?.backgroundColor ?? "white" }}
      >
        {currentOnlineMenu?.categoriesObj?.map((value, i) => {
          return (
            <TabPanel key={i} value={selectedTab} index={i}>
              {value.foodsObj?.map((food, index) => {
                return (
                  <TelescopePopover
                    buttonClassName={"popover-button-classname"}
                    key={index}
                    closeIcon
                    popOverContent={
                      <div className={"with-popover"} style={{ backgroundColor: currentOnlineMenu.backgroundColor }}>
                        {renderFoodObj(
                          food,
                          currentOnlineMenu?.categoriesObj.find((c) => c.foodsObj?.find((f) => f.id === food.id))?.id ??
                            "",
                          true
                        )}
                      </div>
                    }
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "left"
                    }}
                  >
                    {renderFoodObj(
                      food,
                      currentOnlineMenu?.categoriesObj.find((c) => c.foodsObj?.find((f) => f.id === food.id))?.id ?? ""
                    )}
                  </TelescopePopover>
                );
              })}
            </TabPanel>
          );
        })}
      </SwipeableViews>
    );
  }

  return isLoading ? (
    <LoadingPage />
  ) : (
    <ToolBarTemplate
      backgroundColor={currentOnlineMenu.backgroundColor}
      company={currentCompanyInfo}
      titleColor={currentOnlineMenu.titleColor ?? "black"}
    >
      <Box className={"home-tab-area"} style={{ backgroundColor: currentOnlineMenu?.backgroundColor ?? "white" }}>
        {renderTabArea()}
        {isCartActive && (
          <button className="cart-button" onClick={() => navigate(routes.cart)}>
            <ShoppingCart className="icon" />
            <span className="order-count">{getTotalNumberOfOrder()}</span>
          </button>
        )}
      </Box>
      {renderFoodList()}
      {renderGoBackArrowButton()}
    </ToolBarTemplate>
  );
};
export default OnlineMenuHome;

export interface TabPanelProps {
  children?: ReactNode;
  dir?: string;
  index: number;
  value: number;
}
